import { useReducer, useCallback, useMemo } from 'react';
import { ErrorToast, notifySuccess } from '../../utils/Utils';

const initialState = {
  isFetching: false,
  data: null,
  error: null,
  idle: true,
  isError: false,
};

const useAsync = (cb, options = null) => {
  const [state, setState] = useReducer((currentState, action) => ({ ...currentState, ...action }), {
    ...initialState,
    data: options?.initData,
  });
  const isLoading = useMemo(() => state.idle || state.isFetching, [state.idle, state.isFetching]);
  const run = useCallback(
    (opt) => {
      setState({ idle: false, isFetching: true });
      return cb(opt).then(
        (res) => {
          setState({
            data: res?.data?.result,
            isFetching: false,
            error: null,
            isError: false,
          });
          if (options && options?.showSuccessMessage) {
            notifySuccess(options?.showSuccessMessage);
          }
          return res?.data;
        },
        (error) => {
          setState({ isFetching: false, error: error.message, isError: true });
          ErrorToast(error.message);
          return error;
        },
      );
    },
    [cb],
  );

  return { ...state, isLoading, run };
};

export default useAsync;
